import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeClosed = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 12 12",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M.75 4.875s2.25 3 5.25 3 5.25-3 5.25-3m-6.462 2.84-.452 1.441m2.876-1.441.452 1.441M2.461 6.539l-.908 1.155m7.986-1.155.908 1.155"
	})
});
export default SvgEyeClosed;
